let _ = t => t,
  _t,
  _t2,
  _t3;
import styled from 'styled-components';
import { fontSize, colors, fontWeights } from '@ovpn-ui/styles';
import { sidebarAnimation } from '../../Sidebar.constants';
export const FlyoutBase = styled.div(_t || (_t = _`
    position: absolute;

    right: -1px;

    margin-left: 24px;
    overflow: hidden;

    font-weight: ${0};
    font-size: ${0};
    white-space: nowrap;

    background: ${0};

    visibility: hidden;
    cursor: default;
    opacity: 0;

    .sidebar-flyout__title {
        font-weight: ${0};
        font-size: ${0};

        white-space: nowrap;

        cursor: default;
    }

    &:hover {
        visibility: visible;
    }

    transition: visibility ${0}, opacity ${0};
    transition-delay: 65ms;
`), fontWeights.semiBold, fontSize.default, t => t.theme.flyoutSubItemBg, fontWeights.semiBold, fontSize.default, sidebarAnimation, sidebarAnimation);
export const Flyout = styled(FlyoutBase)(_t2 || (_t2 = _`
    padding: 8px 16px;

    color: ${0};

    background-color: ${0};
    border-radius: 8px;
    box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
    transform: translateX(100%);

    .sidebar-flyout__title {
        font-size: ${0};
        line-height: ${0};
    }
`), colors.neutralWhite, colors.neutralTextTitle, fontSize.xSmall, fontSize.default);
export const FlyoutNav = styled(FlyoutBase)(_t3 || (_t3 = _`
    top: 0;

    min-width: 280px;
    height: 100%;

    padding: 32px 16px;

    border-right: 1px solid ${0};

    box-shadow: 0px 4px 8px -4px rgba(24, 39, 75, 0.12);
    transform: translateX(100%);

    .sidebar-flyout__title {
        margin-bottom: 24px;
    }

    nav {
        font-weight: ${0};

        background: ${0};
        cursor: default;

        .sidebar-flyout__sublink {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 0 8px 8px;
            padding: 8px 12px;

            color: ${0};
            white-space: nowrap;
            text-decoration: none;

            border-radius: 8px;
            cursor: pointer;

            user-select: none;

            &:last-child {
                margin-bottom: 0;
            }

            &:hover {
                background: ${0};
            }

            &.active {
                background: ${0};

                &:hover {
                    background: ${0};
                }
            }

            &:focus {
                box-shadow: 0px 0px 0px 4px rgba(59, 145, 241, 0.45);
            }
        }
    }
`), t => t.theme.border, fontWeights.medium, t => t.theme.flyoutSubItemBg, t => t.theme.text, t => t.theme.flyoutSubItemHover, t => t.theme.itemActiveColor, t => t.theme.itemActiveColor);